import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    StateDetails:{},
}

const StateDetailSlice = createSlice({
    name: "StateDetailSlice",
    initialState,

    reducers: {
        StateDetailsData(state, action) {
            return {
                StateDetails: action.payload.StateDetails,
            };
        }
    }
})
export const { StateDetailsData } = StateDetailSlice.actions;
export default StateDetailSlice.reducer;